module.exports = __webpack_public_path__ + "static/media/penne.d37239c4.jpg";